import { Badge, type BadgeProps } from "@fluentui/react-components";
import type { Stato } from "@app/schema";

const colori: Record<Stato, BadgeProps["color"]> = {
  Sottomessa: "informative",
  "Presa visione": "brand",
  "In lavorazione": "warning",
  Bloccata: "severe",
  Respinta: "danger",
  Evasa: "success",
};

export function StatoBadge({ stato, size = "medium" }: { stato?: string; size?: BadgeProps["size"] }) {
  if (!stato) return null;
  return (
    <Badge
      appearance="tint"
      color={colori[stato as Stato] ?? "informative"}
      size={size}
      shape="rounded"
      style={{ whiteSpace: "nowrap", flexShrink: 0 }}
    >
      {stato}
    </Badge>
  );
}
